export var jabraBaseUrl = 'https://www.jabra.com';
export var forbiddenWordsUrl = '/-/media/E01806AF73694C67ABAB240D0FA73C6D.json';
